export const matchesSearch = (values: Array<unknown>, query: string): boolean => (
  values.some((value) =>
    String(value ?? '')
      .toLowerCase()
      .includes(query)
  )
)
